const loaderHandler = {
    hideLoader() {
        if (this.self == undefined) return;
        if (this.self.loadingModal == undefined) return;
        this.self.loadingModal.close();
    },
    showLoader(title, self = this.self) {
        if (self.props && self.props.self) {
            self = self.props.self;
        }
        if (self.props && self.props.self) {
            self = self.props.self;
        }
        if (self == undefined) return;
        if (self.loadingModal == undefined) return;
        self.loadingModal.open();
        this.self = self;
    },
};

export default loaderHandler;
